<template>
  <div :id="id"
       class="o-echarts">

  </div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
import moment from 'moment'
let chart = null
export default {
  name: 'CompleteRateChart',
  props: {
    id: {
      type: String,
      required: false,
      default: 'chart'
    },
    subtext: {
      type: String,
      required: false,
      default: moment().format('YYYY年MM月DD日')
    }
  },
  data () {
    return {
      // id: 'completeRateChart',//地图渲染容器id
      option: {
        title: {
          text: '',
          subtext: '(2020年6月4日)',
          left: 'right'
        },
        // tooltip: {
        //   trigger: "item",
        //   formatter: "{a} <br/>{b} : {c} ({d}%)"
        // },
        tooltip: {
          trigger: 'item',
          formatter: function (params, ticket, callback) {
            // return params.name + "<br>" + params.percent + '%'
            return params.name + '<br>' + '面积：' + params.value.labelValue + '亩' + '<br>' + '占比：' + params.percent + '%'
          }
        },
        dataset: [
          // {
          //   source: [
          //     { 'type': '水稻政策性保险', 'labelValue': 60 },
          //     { 'type': '未完成', 'labelValue': 30 }
          //   ]
          // },
          // {
          //   source: [
          //     { 'type': '大豆政策性保险', 'labelValue': 40 },
          //     { 'type': '未完成', 'labelValue': 30 }
          //   ]
          // },
          // {
          //   source: [
          //     { 'type': '玉米政策性保险', 'labelValue': 80 },
          //     { 'type': '未完成', 'labelValue': 20 }
          //   ]
          // },
        ],
        legend: {
          orient: 'vertical',
          right: 10,
          top: '30%',
          bottom: 20,
          itemGap: 20,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#333'
          },
          icon: 'rect'
          // data: ["水稻政策性保险", "大豆政策性保险", "玉米政策性保险", "未完成"]
        },
        color: ['#1a8dee', '#48ebd0', '#73b4f8', '#13cdcc', '#ff9023'],
        series: [
          {
            // name: "",
            type: 'pie',
            radius: ['46%', '60%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              // position: "inside",
              fontSize: 14,
              color: '#666',
              formatter (val) {
                //   return val.value+'亩';
              }
            },

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            encode: {
              itemName: 'type',
              value: 'labelValue'
            },

            datasetIndex: 0
            // color: ["#1a8dee", "#48ebd0"],
            // data: [
            //   {
            //     // value: 185465,
            //     // name: "水稻政策性保险",
            //     itemStyle: {
            //       color: "#1a8dee"
            //     },
            //     tooltip: {
            //       formatter: "{a}</br>已完成：{c} ({d}%)"
            //     }
            //   },

            //   {
            //     // value: 23000,
            //     // name: "未完成",
            //     itemStyle: {
            //       color: "#48ebd0"
            //     }
            //   }
            // ]
          },
          {
            // name: "大豆政策保险完成比列(%)",
            type: 'pie',
            radius: ['28%', '42%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              // position: "inside",
              fontSize: 14,
              color: '#666',
              formatter (val) {
                //   return val.value+'亩';
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            datasetIndex: 1,
            encode: {
              itemName: 'type',
              value: 'labelValue'
            }
            // color: ["#73b4f8", "#48ebd0"],
            // data: [
            //   {
            //     // value: 182365,
            //     // name: "大豆政策性保险",
            //     itemStyle: {
            //       color: "#73b4f8"
            //     },
            //     tooltip: {
            //       formatter: "{a}</br>已完成{c} ({d}%)"
            //     }
            //   },

            //   {
            //     // value: 25000,
            //     // name: "未完成",
            //     itemStyle: {
            //       color: "#48ebd0"
            //     }
            //   }
            // ]
          },
          {
            // name: "玉米政策保险完成比列(%)",
            type: 'pie',
            radius: ['12%', '24%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              position: 'inside',
              fontSize: 16,
              formatter (val) {
                return val.value
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            datasetIndex: 2,
            encode: {
              itemName: 'type',
              value: 'labelValue'
            }
            // color: ["#13cdcc", "#48ebd0"],
            // data: [
            //   {
            //     // value: 1000000,
            //     // name: "玉米政策性保险",
            //     itemStyle: {
            //       color: "#13cdcc"
            //     },
            //     tooltip: {
            //       formatter: "{a}</br>已完成{c} ({d}%)"
            //     }
            //   },

            //   {
            //     // value: 1500000,
            //     // name: "未完成",
            //     itemStyle: {
            //       color: "#48ebd0"
            //     }
            //   }
            // ]
          },
          {
            // name: "小麦政策保险完成比列(%)",
            type: 'pie',
            radius: [0, '10%'],
            center: ['30%', '50%'],
            label: {
              show: false,
              position: 'inside',
              fontSize: 16,
              formatter (val) {
                return val.value
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: false
            },
            datasetIndex: 3,
            encode: {
              itemName: 'type',
              value: 'labelValue'
            }
          }
        ]

      }
    }
  },
  mounted () {
    // this.initMap()

  },
  watch: {

  },
  methods: {
    listenResize () {
      // 窗口改变大小
      if (chart) {
        chart.resize()
      }
    },
    initMap (optionData) {
      // 设置时间
      this.option.title.subtext = optionData.date || ''
      this.option.dataset = optionData.dataset
      chart = echarts.init(
        document.getElementById(this.id)
      )
      chart.setOption(this.option)
      if (optionData.chartHeight) {
        chart.resize({ height: optionData.chartHeight })
      } else {
        chart.resize({ height: 300 })
      }
    }

  },
  components: {

  }
}
</script>

<style scoped lang="less">
.o-echarts {
  min-width: 30px;
  min-height: 30px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/CompleteRateChart.vue